module.exports = __webpack_public_path__ + "files/5318751421e4a3cfb891421656c8215a.svg";